/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/widgets/warenkoerbe/dashboard.widgets.warenkoerbe.component.ts.
 */
import {Component} from '@angular/core';
import {AppEventService} from '../../../../services/app.event.service';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';

/**
 * Zweck: Beschreibt class DashboardWidgetsWarenkoerbeComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-dashboard-widgets-warenkoerbe',
    templateUrl: 'dashboard.widgets.warenkoerbe.component.html',
    styleUrls: ['dashboard.widgets.warenkoerbe.component.scss'],
    standalone: false
})
export class DashboardWidgetsWarenkoerbeComponent {
  static id = 'DashboardWidgetsWarenkoerbeComponent';
  static cols = 3;
  static rows = 5;
  static label = 'Ihre Warenkörbe';
  static description = 'Zeigt eine Liste Ihrer Warenkörbe an.';

  loading1 = false;
  loading2 = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public svc: AppWarenkorbService, private esvc: AppEventService) {
  }

}
